module.exports = __webpack_public_path__ + "img/beer_id-18.ae9c1c08.png";